import {
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { BasisOverlayTooltipComponent } from './basis-overlay-tooltip.component';
import { ShipmentFlat } from './basis-overlay.container';

export type TooltipType = 'name' | 'plant' | 'all' | null;

@Directive({
  selector: '[prlwBasisOverlayTooltip]',
})
export class BasisOverlayTooltipDirective implements OnDestroy {
  @Input('prlwBasisOverlayTooltip')
  public shipment!: ShipmentFlat;
  @Input()
  public tooltipType: TooltipType = null;
  private _overlayRef?: OverlayRef;
  private _tooltipRef!:
    | EmbeddedViewRef<BasisOverlayTooltipComponent>
    | ComponentRef<BasisOverlayTooltipComponent>;

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly overlay: Overlay,
  ) {}

  @HostListener('mouseenter')
  public open(): void {
    if (!this.tooltipType) {
      return;
    }
    const offsetY = 10;
    const overlayConfig = new OverlayConfig({
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this._elementRef.nativeElement)
        .withPositions([
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
            offsetY,
          },
        ])
        .withPush(false),
      scrollStrategy: this.overlay.scrollStrategies.close(),
    });

    this._overlayRef = this.overlay.create(overlayConfig);
    const modalPortal = new ComponentPortal(BasisOverlayTooltipComponent);
    this._tooltipRef = this._overlayRef.attach(modalPortal);
    this._tooltipRef.instance.name = this.shipment.name;
    this._tooltipRef.instance.plants = this.shipment.plants.split(', ');
    this._tooltipRef.instance.type = this.tooltipType;
  }

  @HostListener('mouseleave')
  public close(): void {
    if (this._overlayRef) {
      this._overlayRef.detach();
    }
  }

  public ngOnDestroy(): void {
    this.close();
  }
}
